import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class PaymentStatusService {
  constructor(private http: HttpUtilService) {}

  /**
   * Retrieves all finance managers.
   * Calls the API: Services/FinanceManagerService.asmx/GetAllBasic
   * @returns Observable containing the list of finance managers.
   */
  getAllFinanceManagers(): Observable<any> {
    return this.http.get(`FinanceManagerService.asmx/GetAllBasic`);
  }

  /**
   * Retrieves active insurance options.
   * Calls the API: Services/InsuranceService.asmx/GetActiveDrpList
   * @returns Observable containing the list of active insurances.
   */
  getActiveInsuranceList(): Observable<any> {
    return this.http.get(`InsuranceService.asmx/GetActiveDrpList`);
  }

  /**
   * Searches payment status based on given search option and text.
   * Calls the API: Services/PaymentStatusService.asmx/Search
   * @param searchOption The field to search by (e.g., ChasisNumber).
   * @param searchText The text to search for.
   * @returns Observable containing the search results.
   */
  searchPaymentStatus(
    searchOption: string,
    searchText: string,
  ): Observable<any> {
    const params = `searchOption=${encodeURIComponent(JSON.stringify(searchOption))}&searchText=${encodeURIComponent(JSON.stringify(searchText))}`;
    return this.http.get(
      `PaymentStatusService.asmx/Search?${params}`,
    );
  }

  savePaymentDetail(payload: any): Observable<any> {
    return this.http.post(
      `PaymentStatusService.asmx/SavePaymentDetail`,
      payload,
    );
  }

  printPaymentStatus(payload: any): Observable<any> {
    return this.http.post(
      `PaymentStatusService.asmx/PrintPaymentStatus`,
      payload,
    );
  }

  submitFullDoc(contractNo: string): Observable<any> {
    const encodedContractNo = encodeURIComponent(
      JSON.stringify(contractNo),
    );
    return this.http.get(
      `PaymentStatusService.asmx/SubmitFullDoc?contractNo=${encodedContractNo}`,
    );
  }

  printParfSettlement(payload: any): Observable<any> {
    return this.http.post(
      `PaymentStatusService.asmx/PrintPARFSettlment`,
      payload,
    );
  }
  updateFields(model: any, fieldName: string): Observable<any> {
    return this.http.post("PaymentStatusService.asmx/UpdateFields", {
      model,
      fieldName,
    });
  }
  proceedToChequeIssue(model: any): Observable<any> {
    return this.http.post(
      "PaymentStatusService.asmx/ProceedToChequeIssue",
      { model },
    );
  }
}
